export enum VoiceOption {
  shimmer = 'shimmer',
  alloy = 'alloy',
  ash = 'ash',
  ballad = 'ballad',
  coral = 'coral',
  echo = 'echo',
  sage = 'sage',
  verse = 'verse',
}

export const VOICE_OPTIONS: { value: VoiceOption; label: string }[] = [
  { value: VoiceOption.shimmer, label: 'Shimmer' },
  { value: VoiceOption.alloy, label: 'Alloy' },
  { value: VoiceOption.ash, label: 'Ash' },
  { value: VoiceOption.ballad, label: 'Ballad' },
  { value: VoiceOption.coral, label: 'Coral' },
  { value: VoiceOption.echo, label: 'Echo' },
  { value: VoiceOption.sage, label: 'Sage' },
  { value: VoiceOption.verse, label: 'Verse' },
]
